import React from 'react';

const questionStemRegex = /^\[question-stem\]([\s\S]*?)\[\/question-stem\]/;

// renders [question-stem]...[/question-stem] as-is in a div
// for when we're not extracting to the right side
export const questionStemRule = {
  order: 0,
  match: (source) => questionStemRegex.exec(source),
  parse: (capture, parse) => ({
    // same workaround as in collapsibleArea.js
    // so block parser works as expected
    content: parse(`\n\n${capture[1].trim()}\n\n`)
  }),
  react: (node, output) => {
    return <div>{output(node.content)}</div>;
  }
};
